import React from "react";
import {
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
    Button,
    Pagination,
    Tooltip,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate } from "react-router-dom";
import { useProyecto } from "../../common/ProyectoProvider";
import { ProyectoData } from "../../interfaces/PROYECTOS/Proyectos";

interface ProyectosTableProps {
    rowsPerPage: number;
    setRowsPerPage: (value: number) => void;
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    displayedRows: Array<ProyectoData>;
    totalPages: number;
    currentPage: number;
    handlePageChange: (event: any, value: number) => void;
    getIconColor: (estado: string) => "success" | "disabled";
}



export const ProyectosTable: React.FC<ProyectosTableProps> = ({
    rowsPerPage,
    setRowsPerPage,
    searchTerm,
    setSearchTerm,
    displayedRows,
    totalPages,
    currentPage,
    handlePageChange,
    getIconColor,
}) => {
    
    const { setIdProy } = useProyecto();

    let history = useNavigate();

    const goToProyecto = (site: string, idProyecto: number) => {
        setIdProy(idProyecto);
        history(site);
    }

    const goToNavigation = (site:string) =>{
        history(site)
      }


    return (
        <Box>
            <Typography
                variant="h6"
                gutterBottom
                sx={{ marginBottom: "20px", fontSize: "16px", color: "#243165" }}
            >
                PROYECTOS APROBADOS
            </Typography>

            {/* Configuración de tabla */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                {/* Selector de cantidad por página y búsqueda */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <FormControl variant="outlined" size="small" sx={{ width: 150 }}>
                        <InputLabel id="rows-per-page-label">Mostrar</InputLabel>
                        <Select
                            labelId="rows-per-page-label"
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(Number(e.target.value))}
                            label="Mostrar"
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        variant="outlined"
                        size="small"
                        label="Buscar por título"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ width: 300 }}
                    />
                </Box>
            </Box>

            {/* Tabla */}
            <TableContainer component={Paper} elevation={3}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#243165" }}>
                            <TableCell
                                align="left"
                                sx={{ color: "#FFFFFF", fontWeight: "bold" }}
                            >
                                Proyecto
                            </TableCell>
                            <TableCell
                                align="left"
                                sx={{ color: "#FFFFFF", fontWeight: "bold" }}
                            >
                                Título
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ color: "#FFFFFF", fontWeight: "bold" }}
                            >
                                Estado
                            </TableCell>
                            <TableCell
                                align="center"
                                sx={{ color: "#FFFFFF", fontWeight: "bold" }}
                            >
                                Opciones
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedRows.map((proyecto) => (
                            <TableRow key={proyecto.idProyecto}>
                                <TableCell align="left">{proyecto.codigo}</TableCell>
                                <TableCell align="left">{proyecto.titulo}</TableCell>
                                <TableCell align="center">{proyecto.estado}</TableCell>
                                <TableCell align="center">
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Tooltip title = {"Ayudantías"} placement="top" arrow>
                                            {/* <IconButton onClick={()=>goToNavigation('/Proyectos/Ayudantias/'+proyecto.idProyecto)} >
                                                <DescriptionIcon
                                                    color={getIconColor(proyecto.estado)}
                                                />
                                            </IconButton> */}

                                            <IconButton onClick={()=>goToProyecto('/Proyectos/Ayudantias', proyecto.idProyecto)} >
                                                <DescriptionIcon
                                                    color={getIconColor(proyecto.estado)}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Paginación */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                />
            </Box>
        </Box>
    );
};
